import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Project from '../tabs/Project';

const useStyles = makeStyles((theme) => ({
  paragraph: {
    whiteSpace: 'pre-line',
  },
  title: {
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1) / 2,
    fontWeight: 500
  },
  subtitle: {
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(3),
    fontWeight: 300
  },
  grid: {
    marginTop: theme.spacing(2),
  }
}));

export default (props) => {
  const classes = useStyles();
  return (
    <>
      <h2 className={classes.title}>{props.config.title}</h2>
      <h3 className={classes.subtitle}>{props.config.subtitle}</h3>
      <p className={classes.paragraph}>{props.config.description}</p>
      <Grid container direction="row" alignItems="flex-start" spacing={3} className={classes.grid}>
        {props.config.projects && props.config.projects.map((project, index) => (
          <Grid item md={4} sm={6} xs={12} key={index}>
            <Project config={project} />
          </Grid>
        ))}
      </Grid>
    </>
  );
}